import type { Bcp47Locale } from '@backmarket/http-api/src/standards/Locale'

import {
  DATE_FORMAT,
  DATE_FORMAT_SHORT,
  SHORT_DATE_FORMAT_BY_LOCALE,
} from './deliveryDate.constants'

export const getShortDate = (
  date: Date,
  currentLocale: Bcp47Locale,
  format: 'earliest' | 'lastest',
) => {
  if (SHORT_DATE_FORMAT_BY_LOCALE[currentLocale] === format) {
    return date.toLocaleDateString(currentLocale, DATE_FORMAT_SHORT)
  }

  return date.toLocaleDateString(currentLocale, DATE_FORMAT)
}

export function formatDeliveryDateRange(
  earliestDate: Date,
  latestDate: Date,
  locale: Bcp47Locale,
): { earliest: string; latest: string } {
  if (latestDate.getMonth() !== earliestDate.getMonth()) {
    return {
      earliest: earliestDate.toLocaleDateString(locale, DATE_FORMAT),
      latest: latestDate.toLocaleDateString(locale, DATE_FORMAT),
    }
  }

  return {
    earliest: getShortDate(earliestDate, locale, 'lastest'),
    latest: getShortDate(latestDate, locale, 'earliest'),
  }
}
